module.exports = __webpack_public_path__ + "static/img/kc_pic.5abefab9.jpg";